import { MdDeleteForever } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import formatDateIndian from "../../common/formatDateIndian.js";

const QuotesFiles = ({ setFiles, files, isEditing }) => {
  const handleAttachFile = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    if (selectedFile.type === "application/pdf") {
      const newFile = {
        id: Date.now(),
        seq_No: 0,
        file_Name_Path: selectedFile.name,
        file: selectedFile,
        file_Name: selectedFile.name,
        attach_Date: new Date().toLocaleString(),
        quote_Amount: "",
        is_Active: 0,
      };

      setFiles((prev) => {
        const updated = isEditing
          ? [...prev, newFile]
          : [...prev.map((f) => ({ ...f, is_Active: false })), newFile];

        return updated;
      });
    } else {
      alert("Only PDF files are allowed.");
    }
  };

  const handleFilesDelete = async (fileId) => {
    try {
      setFiles((prev) =>
        prev.filter((f) => {
          const isNew = f.seq_No === 0 || !f.seq_No;
          return isNew ? f.id !== fileId : f.seq_No !== fileId;
        })
      );
      if (fileId && typeof fileId === "number" && fileId > 0) {
        await axiosInstance.delete(`WindowQuotation/DeleteFile/${fileId}`);
      }
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="overflow-x-auto">
        <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-base font-semibold text-[#405189]">Quotes</h2>
          <div className="flex items-center gap-3">
            <input
              type="file"
              accept="application/pdf"
              onChange={handleAttachFile}
              className="hidden"
              id="file-upload"
            />
            <label
              htmlFor="file-upload"
              className="cursor-pointer px-4 py-2 border border-transparent text-sm font-medium rounded text-white bg-secondary"
            >
              Attach File
            </label>
          </div>
        </div>
        <div className="px-6 py-4">
          <table className="w-full divide-y divide-gray">
            <thead className="bg-gray">
              <tr>
                {[
                  "seq No",
                  "File Name",
                  "Date Added",
                  "Quote Amount",
                  "Active",
                  "Action",
                ].map((header, index) => (
                  <th
                    key={index}
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {files?.map((file) => {
                return (
                  <tr key={file.seq_No || file.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      {file.seq_No}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600">
                      <a
                        href={file.file_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {file.file_Name ||
                          file.file_Name_Path ||
                          (file.file && file.file.name)}
                      </a>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      {formatDateIndian(file.attach_Date)}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <input
                        type="text"
                        name="quote_Amount"
                        value={file.quote_Amount}
                        onChange={(e) =>
                          setFiles((prev) =>
                            prev.map((f) =>
                              (f.seq_No || f.id) === (file.seq_No || file.id)
                                ? { ...f, quote_Amount: e.target.value }
                                : f
                            )
                          )
                        }
                        className="border rounded px-2 py-1 w-20 outline-none focus:ring-2 focus:ring-primary"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <input
                        type="radio"
                        name="is_Active"
                        checked={file.is_Active}
                        onChange={() =>
                          setFiles((prevFiles) =>
                            prevFiles.map((f) => ({
                              ...f,
                              is_Active: f === file,
                            }))
                          )
                        }
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm">
                      <button
                        type="button"
                        onClick={() =>
                          handleFilesDelete(file.seq_No || file.id)
                        }
                      >
                        <MdDeleteForever className="text-danger w-10 h-10 bg-red-100 p-2 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default QuotesFiles;
